import React from "react";
import Button from "@mui/material/Button";
import { verbalTheme } from "../../layout/themes/verbal.theme";
import { ThemeProvider, Theme, StyledEngineProvider } from "@mui/material";
import { useSurveyDialog } from "../../public/hooks/surveyDialog.context";
import { VDialog } from "../../../core/components/VDialog";
import OptOutImg from "../../../img/opt-out.svg";

declare module "@mui/styles/defaultTheme" {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface DefaultTheme extends Theme {}
}

export const SurveyDialogOptedOut = (): JSX.Element => {
    const { openDialog, shouldOpenDialog } = useSurveyDialog();

    return (
        <StyledEngineProvider injectFirst>
            (
            <ThemeProvider theme={verbalTheme}>
                <VDialog
                    icon={<img src={OptOutImg} />}
                    open={openDialog}
                    header={"Opted out"}
                    content={"You have now been opted out of recieving surveys for the remainder of this programme"}
                    actions={
                        <>
                            <Button
                                onClick={() => shouldOpenDialog(false)}
                                fullWidth
                                variant="contained"
                                size={"large"}
                                color="primary"
                            >
                                Return to dashboard
                            </Button>
                        </>
                    }
                />
            </ThemeProvider>
            )
        </StyledEngineProvider>
    );
};
export default SurveyDialogOptedOut;
